import { Suspense, lazy } from "react";

// Loaded on demand: the page uses the platform's settings parts, which the
// package entry must not import.
const Page = lazy(() => import("./SensitivitySettings").then((m) => ({ default: m.SensitivitySettings })));

/** Project → Settings → Sensitivity, in the Governance section of the menu. */
export const SensitivitySettingsPage = (props) => (
  <Suspense fallback={null}>
    <Page {...props} />
  </Suspense>
);

SensitivitySettingsPage.title = "Sensitivity";
SensitivitySettingsPage.path = "/sensitivity";
SensitivitySettingsPage.exact = true;
SensitivitySettingsPage.menuSection = "governance";
